export default __webpack_public_path__ + "static/media/GSX-2018.2aa55594.jpg";